

export type GameSessionChanged = (session: GameSession) => void;

export interface IGameSession
{
	//Apply(): void;
	//SetChangedCallback(callback: GameSessionChanged): void;
}


export class GameSession implements IGameSession
{
	protected changedCallback: GameSessionChanged = null;
	protected SessionChanged(): void {
		if (this.changedCallback != null) {
			this.changedCallback(this);
		}
	}	

	public SetChangedCallback(callback: GameSessionChanged): void {
		this.changedCallback = callback;
	}
}

export class DefaultGameSession extends GameSession 
{
}